<template>
  <section class="result__content">
    <div class="result__content--list">
      <div class="text-center font-bold mt-5">{{ $t('SEARCH_OFFER') }}</div>
    </div>
  </section>
</template>
